export default __webpack_public_path__ + "static/media/solution.427da4bc.svg";